<template>
  <div class="center">
    <div class="waitingcom_title">
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="练习名称：" prop="examName">
          <el-input
            v-model.trim="formLabelAlign.examName"
            placeholder="请输入考试名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="组卷模式：" prop="examModel">
          <el-select
            v-model="formLabelAlign.examModel"
            label="全部"
            @change="searchChang"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="getoptions(item.value)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="练习状态：" prop="examStatus">
          <el-select v-model="formLabelAlign.examStatus" @change="searchChang">
            <el-option
              v-for="item in examStatusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间：" prop="examTime">
          <div class="block">
            <el-date-picker
              @change="searchChang"
              v-model="examTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="创建开始日期"
              end-placeholder="创建结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          @click="searchData()"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <!-- button按钮 -->
    <div class="oper_box">
      <el-button @click="addtest" v-if="$root.$hasbtn('新增')">
        <i class="iconfont icon-action-add-hover"></i>新增
      </el-button>
      <!-- <el-button @click="independent()">
        <i class="iconfont icon-jiami"></i>加密
      </el-button> -->
      <!-- <el-button> <i class="iconfont icon-daochu"></i>导出成绩</el-button> -->
      <!-- <el-button @click="batchdelList">
        <i class="iconfont icon-batch-shanchu"></i>批量删除
      </el-button> -->
    </div>
    <!-- 表单内容 -->
    <div class="hos_table" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :cell-class-name="stateColor"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="StepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column
          type="selection"
          width="50px"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150px"
          label-height="50"
          align="center"
        >
          <template slot-scope="scope">
            <p v-if="index == 0">
              {{
                scope.$index +
                1 +
                formLabelAlign.pageIndex * formLabelAlign.eachPageNum
              }}
            </p>
            <p v-if="index == 1">
              <i
                class="isselectico iconfont icon-ico"
                @click.stop="openqrwindows(scope.row)"
              ></i>
              {{ scope.row.ExamName }}
              <el-tooltip placement="right-start" effect="darkts">
                <div slot="content" class="bubbles_box">
                  <div
                    class="bubbles_son"
                    style="color: #ffffff; background-color: #00d254"
                  >
                    <p>总分:{{ scope.row.TotalScore }}分</p>
                    <p>时间:{{ scope.row.SpendTime }}分钟</p>
                  </div>

                  <br />
                  <div
                    class="bubbles_son"
                    style="color: #ffffff; background-color: #00d254"
                  >
                    <p>参考人员:{{ scope.row.StudentCount }}人</p>
                    <p>及格线:{{ scope.row.PassScore }}分</p>
                  </div>
                </div>

                <i class="iconfont icon-tishi"></i>
              </el-tooltip>
            </p>
            <p v-if="index == 2">
              {{ scope.row.PaperModeExam }}
            </p>
            <p v-if="index == 3">
              {{ scope.row.PaperModeName }}
            </p>
            <p v-if="index == 4">
              {{ scope.row.BeginTime1 }}
            </p>
            <p v-if="index == 5" class="teststatus">
              {{ scope.row.IsPublish }}
            </p>
            <p v-if="index == 6">
              {{ scope.row.IsLock }}
            </p>
            <p v-if="index == 7">
              {{ $moment(scope.row.CreateTime).format("YYYY-MM-DD HH:mm:ss") }}
            </p>
            <p v-if="index == 8">
              {{ scope.row.UserName }}
            </p>
            <div v-if="index == 9">
              <div class="operation_box">
                <el-button
                  @click.stop="handleClick(scope.row)"
                  type="text"
                  size="small"
                  v-if="$root.$hasbtn('编辑')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="$root.$hasbtn('导出')"
                  @click.stop="opendowmtest(scope.row)"
                  >导出</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="$root.$hasbtn('复制')"
                  @click.stop="copy(scope.row, scope.$index)"
                  >复制</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="$root.$hasbtn('结束练习')"
                  @click.stop="examiopen(scope.row, scope.$index)"
                  :disabled="scope.row.IsPublish == '练习结束'"
                  >{{
                    scope.row.IsLock == "练习开启"
                      ? "结束练习"
                      : scope.row.IsLock == "练习关闭"
                      ? "开启练习"
                      : ""
                  }}</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="$root.$hasbtn('删除')"
                  @click.stop="examDelete(scope.row, scope.$index)"
                  >删除</el-button
                >
              </div>
            </div>
            <p v-if="index == 10">序号</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>
          共有{{ total }}条记录，当前第{{ formLabelAlign.pageIndex + 1 }}/{{
            pagesun
          }}页
        </p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="showpageindex"
          :page-size="formLabelAlign.eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 下载弹窗 -->
    <div class="everywhere">
      <el-dialog
        title="导出练习"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <span>确定导出{{ isselecttest.ExamName }} 练习吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dowmtest"> 确 定 </el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 二维码下载弹窗 -->
    <div class="qrcodeView">
      <el-dialog
        title="二维码下载"
        :visible.sync="qrdialogVisible"
        width="18%"
        :close-on-click-modal="false"
      >
        <p class="qr_p">练习名称：{{ practiceObj.practiceName }}</p>
        <p class="qr_p">练习码：{{ practiceObj.practiceID }}</p>
        <div class="qr_v">
          <vueqr
            :bgSrc="config.logo"
            :logoSrc="config.imagePath"
            :text="config.value"
            :size="250"
            ref="isAn"
          ></vueqr>
        </div>
        <div class="qr_v">
          <el-button type="text" size="small" @click="download" class="mr24"
            >下载二维码</el-button
          >
        </div>
        <p class="red_p"><span>注:</span> 当前二维码只支持医考拉扫码！</p>
        <p class="exam_p">练习码通过医考拉首页搜索考试！</p>
        <p class="exam_p">二维码通过医考拉首页扫码考试！</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="qrdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qrdialogVisible = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 生成完整的二维码图片 -->
    <div v-if="qrdialogVisible" ref="codeDownLoad" class="qrcodeView downLoad">
      <p class="qr_p">练习名称：{{ practiceObj.practiceName }}</p>
      <p class="qr_p">练习码：{{ practiceObj.practiceID }}</p>
      <vueqr
        :bgSrc="config.logo"
        :logoSrc="config.imagePath"
        :text="config.value"
        :size="250"
      ></vueqr>
      <p class="red_p"><span>注:</span> 当前二维码只支持医考拉扫码！</p>
      <p class="exam_p">练习码通过医考拉首页搜索考试！</p>
      <p class="exam_p">二维码通过医考拉首页扫码考试！</p>
    </div>
    <div v-if="qrdialogVisible" class="flex_">
      <img ref="saveImage" src="" alt="" />
    </div>
    <!-- 密码验证弹窗 -->
    <div class="password_view">
      <el-dialog
        title="密码验证"
        :visible.sync="deleteVisibleis"
        :close-on-click-modal="false"
      >
        <div class="password_mian">
          <p>您已经设置了练习密码，验证后使用</p>
          <el-input
            v-model.trim="password"
            placeholder="请输入您的密码"
            :type="flag3 ? 'password' : 'text'"
            autocomplete="off"
          >
            <template>
              <i
                slot="suffix"
                class="iconfont"
                :class="flag3 ? 'icon-yincangmima' : 'icon-eyes'"
                @click="flag3 = !flag3"
              ></i>
            </template>
          </el-input>
          <span class="verifyError" v-show="verifyError === true">{{
            IsState
          }}</span>
          <p>
            如果您忘记了独立密码，请联系我们的业务经理协助处理，或致
            电0772-3998898
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="(deleteVisibleis = false), (IsState = ''), (password = '')"
            >取 消</el-button
          >
          <el-button type="primary" :loading="sundflag" @click="verifyPwd()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 弹窗 -->
    <Popup ref="popup" :statePopupstatus="statePopupstatus" />
    <!-- 弹框 -->
    <sys-dialog
      :title="editTimeDialog.title"
      :width="editTimeDialog.width"
      :height="editTimeDialog.height"
      :visible="editTimeDialog.visible"
      @onConfirm="editConfirm"
      @onClose="editClose"
    >
      <div slot="content" class="message-text">
        <div class="bacle_input">
          <h5>考试时间：</h5>
          <div class="examTimeSelect">
            <el-date-picker
              v-model="timeSelect"
              @change="timechange"
              value-format="yyyy-MM-dd HH:mm"
              class="standard_input"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="bacle_input">
          <h5>答题时长：</h5>
          <el-input
            v-model="timeValue"
            maxlength="3"
            placeholder="不应低于60分钟"
            class="standard_input"
          ></el-input>
          <p>分钟</p>
        </div>
      </div>
    </sys-dialog>
  </div>
</template>

<script>
import $examApi from "@/api/examApi.js";
import SysDialog from "@/components/system/SysDialog";
import systemclass from "@/api/systemclassification";
import { BASEUrl } from "@/utils/request";
import jisuan from "@/utils/rem";
import vueqr from "vue-qr";
import Popup from "../theonlineTest/published/components/Popup.vue";
import { getexamList, examDelete, examDeleteArr } from "@/api/index.js";
import { verifyCryptoPwd, checkCryptoPwd } from "@/api/examination.js";
import md5 from "js-md5";
import getappstyle from "@/api/questionbank";
import loginvuex from "@/store/index";
import qs from "qs";
import html2canvas from "html2canvas";
import { hybrid } from "@/mixin/mixin";
import training from "@/api/trainingApi";
import { typeTestPaper } from "@/utils/topicImg"; // 题型图片处理
export default {
  data() {
    return {
      //上一次开始时间
      lastBeginTime: "",
      examId: "",
      timeSelect: [],
      timeValue: "",
      stateArr: [], //存储开始时间和结束时间。
      urelname: "www.baidu.com",
      dialogVisible: false, //弹窗显示
      qrdialogVisible: false, //二维码扫描的弹窗
      config: {
        //二维码内的信息
        value: "", //显示的值、跳转的地址
        imagePath: require("@/assets/yunlogo.png"), //中间logo的地址
      },
      isselecttest: "", //当前选择的试卷的详情信息
      input: "",
      value: "",
      loading: true,
      value1: "",
      userphone: "",
      IsState: "",
      sundflag: false, // 防抖
      statePopupstatus: {}, //当前选中行的信息。
      statePopupindex: "",
      labelPosition: "right",
      flag3: true, // 弹窗的矢量图
      verifyError: false, // 校验提示语
      isRight: "", //密码是否正确状态
      deleteVisibleis: false, // 校验密码的弹窗
      password: "", // 弹窗的密码
      // emitStatus:'', // 接口判断
      deleteArr: [],
      examTime: "", // 考试时间
      formLabelAlign: {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        operatUserID: "",
        type: 1, //0是考试。1是练习
        pageIndex: 0,
        eachPageNum: 10, //当前也多少条数。
        examName: "", // 考试名称
        examModel: "", // 组卷模式
        examStatus: "", // 考试状态
        createBeginTime: "", //创建开始时间
        createEndTime: "", //创建结束时间
      },
      showpageindex: 1, //显示的索引盒子
      getDataCondition: {
        examName: "",
      },
      multipleSelection: [], // 表单选中
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      options: [
        {
          label: "全部",
        },
        {
          value: "unified_db",
          label: "智能组卷",
        },
        {
          value: "unified_exam",
          label: "试卷组卷",
        },
        {
          value: "sg_db",
          label: "精准组卷",
        },
        {
          value: "unified_Proportion",
          label: "权重组卷",
        },
      ],
      examStatusArr: [
        {
          label: "全部",
        },
        {
          value: "0",
          label: "待练习",
        },
        {
          value: "1",
          label: "练习中",
        },
        {
          value: "2",
          label: "练习结束",
        },
      ],
      formColumns: [
        {
          prop: "xuhao",
          label: "序号",
          width: jisuan(50, document.body.clientWidth),
        },
        {
          prop: "testname",
          label: "练习名称",
          width: "280rem",
        },
        {
          prop: "PaperModeExam",
          label: "组卷模式",
          width: jisuan(100, document.body.clientWidth),
        },
        {
          prop: "PaperModeName",
          label: "命题方式",
          width: jisuan(100, document.body.clientWidth),
        },
        {
          prop: "BeginTime1",
          label: "练习时间",
          width: jisuan(260, document.body.clientWidth),
        },
        {
          prop: "IsPublish",
          label: "练习状态",
          width: jisuan(120, document.body.clientWidth),
        },
        {
          prop: "IsLock",
          label: "考场状态",
          width: jisuan(100, document.body.clientWidth),
        },
        // {
        //   prop: "AlreadyStuCount",
        //   label: "已考人数(人)",
        // },
        // {
        //   prop: "StudentCount1",
        //   label: "待考人数(人)",
        // },
        {
          prop: "CreateTime",
          label: "创建时间",
          width: jisuan(160, document.body.clientWidth),
        },
        {
          prop: "UserName",
          label: "组卷人",
        },
        {
          prop: "address",
          label: "操作",
          width: jisuan(280, document.body.clientWidth),
        },
      ],
      // checkcode: ObtainData,
      getData: [],
      currentPage3: 0, //  当前页数
      reqcurrentPage3: 0, //请求的页码数
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100, //总条数
      //   testtype: [], //传输给编辑页面的数据
      rendersum: [],
      stateFan: 1, // 0代表是考试，1代表练习
      practiceObj: {
        practiceId: "", // 练习ID
        practiceName: "", // 练习名称
      },
      FileStream: "",
    };
  },
  props: ["cutcoms"],
  components: {
    Popup,
    vueqr,
    SysDialog,
  },
  mixins: [hybrid],
  methods: {
    // chang搜索
    searchChang() {
      this.loading = true;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      if (this.examTime == null) {
        this.formLabelAlign.createBeginTime = "";
        this.formLabelAlign.createEndTime = "";
      }
      this.getDatalist();
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    // 下载二维码
    download() {
      let qrcodeImg = this.$refs.saveImage.src;
      let image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      let that = this;
      image.onload = function () {
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = that.projectName || "myPractice";
        a.href = qrcodeImg;
        a.dispatchEvent(event);
      };
      image.src = qrcodeImg;
    },
    handleClick(row) {
      this.testtype = [];
      this.statePopupstatus = row;
      if (row.IsPublish === "练习中") {
        this.examId = row.ExamID;
        this.lastBeginTime = row.BeginTime;
        this.timeSelect = [];
        this.timeSelect[0] = this.$moment(row.BeginTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.timeSelect[1] = this.$moment(row.EndTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.timeValue = row.SpendTime;
        this.editTimeDialog.visible = true;
      } else {
        // 1.如果为待考试和考试结束可以去编辑
        // 2.考试中  考场关闭 可以去编辑
        // 3.只要有人在考试，就不能进去编辑
        // 4.考试中 ，考场开启 状态不准去编辑
        if (row.IsPublish === "练习中" && row.IsLock === "练习开启") {
          this.$refs.popup.fang = true;
          this.$refs.popup.dialogVisibleObj.editorIntercept = true;
        } else if (row.IsPublish === "练习中" && row.AlreadyStuCount > 0) {
          this.$refs.popup.fang = false;
          this.$refs.popup.dialogVisibleObj.editorIntercept = true;
        } else {
          localStorage.setItem("isreload", true);
          // sessionStorage.setItem("examState", true); // 是否是考试进入 此状态表示是否有批量导入考生
          this.Buriedpoint({
            code: "OnlinePractice:Testpapers:edit",
            parent_code: "OnlinePractice:Testpapers",
          });
          this.cutcoms(2);
        }
      }
    },
    parallelism(e) {
      this.userphone = e;
      console.log("sss");
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.formLabelAlign.eachPageNum = val;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.formLabelAlign.pageIndex = val - 1;
      this.loading = true;
      //  sessionStorage.setItem("pageIndex", val - 1);
      this.getDatalist();
    },

    handleSelectionChange(val) {
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      this.multipleSelection = val; // 批量删除多选状态
      val.forEach((v) => {
        this.multipleSelectionIds.push(v.ExamID);
      });
      this.multipleSelectionCount = this.multipleSelection.length;
      console.log(this.multipleSelectionIds, "<<=====multipleSelectionIds");
    },
    getRowKeyOfTarget(row) {
      return row.ExamID;
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 考试状态
    ChannelMerger() {
      // 组卷模式
      this.getData = this.getData.map((item) => {
        if (item.PaperMode === "unified_db") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "智能组卷";
        } else if (item.PaperMode === "random_db") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "智能组卷";
        } else if (item.PaperMode === "unified_exam") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "试卷组卷";
        } else if (item.PaperMode === "random_exam") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "试卷组卷";
        } else if (item.PaperMode === "unified_Proportion") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "权重组卷";
        } else if (item.PaperMode === "random_Proportion") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "权重组卷";
        } else if (item.PaperMode === "sg_db") {
          item.PaperModeName = "手动命题";
          item.PaperModeExam = "精准组卷";
        } else if (item.PaperMode === "paper") {
          item.PaperModeExam = "纸质试卷";
        }
        // 时间拼接
        item.BeginTime1 =
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
          "-" +
          this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
        // 时间处理
        if (item.BeginTime1 == "Invalid date-Invalid date") {
          item.BeginTime1 = "暂无";
        }
        // 代考人数的计算
        item.StudentCount1 = item.StudentCount - item.AlreadyStuCount;
        if (item.StudentCount1 < 0) {
          item.StudentCount1 = 0;
        }

        // 考试状态
        if (item.BeginTime > item.ServerTime && item.IsPublish === 1) {
          this.$set(item, "IsPublish", "待练习");
        }
        if (
          item.ServerTime >= item.BeginTime &&
          item.IsPublish === 1 &&
          item.ServerTime < item.EndTime
        ) {
          this.$set(item, "IsPublish", "练习中");
        }
        if (item.ServerTime > item.EndTime && item.IsPublish === 1) {
          this.$set(item, "IsPublish", "练习结束");
        }
        return item;
      });
    },
    //   referoptions(){},
    // 重置
    resetForm(formExamin) {
      this.Buriedpoint(
        {
          code: "OnlinePractice:Testpapers:rest",
          parent_code: "OnlinePractice:Testpapers",
        },
        "statetime"
      );
      this.$refs[formExamin].resetFields();
      // this.reqcurrentPage3 = 0;
      this.loading = true;
      this.examTime = "";
      this.showpageindex = 1;
      this.formLabelAlign.pageIndex = 0;
      this.formLabelAlign.createBeginTime = "";
      this.formLabelAlign.createEndTime = "";
      this.getDataCondition.examName = "";
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.getDatalist();
    },
    // 考场状态
    examisState() {
      this.getData = this.getData.map((item) => {
        if (item.IsLock === 0) {
          item.IsLock = "练习开启";
        } else if (item.IsLock === 1) {
          item.IsLock = "练习关闭";
        }

        return item;
      });
    },
    // 新增
    addtest() {
      localStorage.setItem("isreload", true);
      // sessionStorage.setItem("examState", true); // 是否是考试进入 此状态表示是否有批量导入考生
      sessionStorage.setItem("practice", true);
      this.Buriedpoint({
        code: "OnlinePractice:Testpapers:add",
        parent_code: "OnlinePractice:Testpapers",
      });
      this.cutcoms(1);
    },
    // 考场开启的按钮
    examiopen(row, index) {
      this.Buriedpoint(
        {
          code: "OnlinePractice:Testpapers:endPractice",
          parent_code: "OnlinePractice:Testpapers",
        },
        "statetime"
      );
      row.index = index;
      this.statePopupstatus = row;
      if (row.IsLock == "练习开启") {
        this.$refs.popup.dialogVisibleObj.centerDialogVisible = true;
      } else {
        this.$refs.popup.changetesttype();
      }
    },
    // 考生结束删除
    examDelete(row, index) {
      this.Buriedpoint(
        {
          code: "OnlinePractice:Testpapers:delete",
          parent_code: "OnlinePractice:Testpapers",
        },
        "statetime"
      );
      this.statePopupstatus = row;
      this.$refs.popup.dialogVisibleObj.deleteVisible = true;
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      //   console.log('object', row, column, rowIndex, columnIndex)
      if (row.IsPublish === "练习中" && columnIndex === 6) {
        return "yellow";
      } else if (row.IsPublish === "练习结束" && columnIndex === 6) {
        return "red";
      } else if (row.IsPublish === "待练习" && columnIndex === 6) {
        return "green";
      } else if (row.IsLock === "练习开启" && columnIndex === 7) {
        return "gray";
      } else if (row.IsLock === "练习关闭" && columnIndex === 7) {
        return "redtwo";
      }
    },
    // 复制功能
    copy(row, index) {
      this.Buriedpoint(
        {
          code: "OnlinePractice:Testpapers:copy",
          parent_code: "OnlinePractice:Testpapers",
        },
        "statetime"
      );
      this.statePopupstatus = row;
      // console.log(row);
      if (row.PaperModeName === "随机命题") {
        this.$refs.popup.dialogVisibleObj.randomCopy = true;
      } else {
        this.$refs.popup.dialogVisibleObj.copyVisible = true;
      }
      // this.$refs.popup.dialogVisibleObj.copyVisible = true;
    },
    // 批量删除
    batchdelList() {
      const ids = this.multipleSelectionIds;
      console.log(this.multipleSelection.HospitalID);
      if (ids.length <= 0) {
        this.$message({
          message: "警告,当前未勾选要批量删除的试卷",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将批量删除该账户, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 发送请求
          let params = {
            examIDArr: `[${ids}]`,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            hid: this.multipleSelection.HospitalID,
          };
          const Data = await examDeleteArr(params);
          if (Data.status === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.formLabelAlign.pageIndex = 0;
            this.getDatalist(); // 重新发起请求
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      if (ids.length <= 0) return;
    },
    //获取选中的optins
    getoptions(value) {
      console.log(value);
      console.log("ssss");
    },
    // 从试卷中添加考生-试卷列表
    async getDatalist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.createBeginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.createEndTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.formLabelAlign.examName = this.getDataCondition.examName;
      const Data = await getexamList(qs.stringify(this.formLabelAlign));
      if (Data.data.Status == 200) {
        //  this.loading = false;
        //这里吧分页器也选出来。
        this.total = Data.data.Data.count;
        this.getData = Data.data.Data.data;
        this.pagesun = Data.data.Data.pageCount;
        let a = this.formLabelAlign.createBeginTime;
        console.log(a);
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.examisState();
        this.ChannelMerger();
      } else {
        this.$message.error("数据获取不到");
      }
    },
    // 搜索
    searchData() {
      this.Buriedpoint(
        {
          code: "OnlinePractice:Testpapers:search",
          parent_code: "OnlinePractice:Testpapers",
        },
        "statetime"
      );
      this.loading = true;
      this.formLabelAlign.pageIndex = 0;
      if (this.formLabelAlign.examName) {
        this.getDataCondition.examName = this.formLabelAlign.examName;
      } else {
        this.getDataCondition.examName = "";
      }
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.getDatalist();
    },
    //打开导出试卷的确认窗口
    async opendowmtest(item) {
      this.Buriedpoint(
        {
          code: "OnlinePractice:Testpapers:export",
          parent_code: "OnlinePractice:Testpapers",
        },
        "statetime"
      );
      console.log(item);
      this.isselecttest = item;
      //  this.dialogVisible = true;
      //请求远程服务器下载文件
      let parmas = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examID: item.ExamID,
        isAnswer: 0,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      let res = await getappstyle.getNewAspx(qs.stringify(parmas));
      if (res.status == "200") {
        this.dialogVisible = true;
        this.FileStream = res.data;
      } else {
        this.$message.error(res.statusText);
      }
    },
    //导出试卷功能
    dowmtest() {
      this.paperloading = true;
      // let link = document.createElement("a");
      // link.style.display = "none";
      // let url = `${BASEUrl.baseurTwo}/word/${this.isselecttest.ExamID}.zip`;
      // link.href = url;
      // link.setAttribute("download", this.isselecttest.ExamID + ".zip");
      // document.body.appendChild(link);
      // link.click();
      // //释放URL对象所占资源
      // window.URL.revokeObjectURL(url);
      // //用完即删
      // document.body.removeChild(link);
      const blob = new Blob([this.FileStream]);
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", `${this.isselecttest.ExamName}.zip`);
      link.click();
      link = null;
      this.dialogVisible = false;
      this.paperloading = false;
    },
    opennewurl(src) {
      window.location.href = src;
    },
    openqrwindows(testid) {
      //打开二维码传入试卷ID
      console.log(testid);
      if (testid.PaperModeName == "随机命题") {
        this.$alert("当前命题方式不支持扫码进入", "温馨提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      } else {
        this.qrdialogVisible = true;
        this.practiceObj.practiceID = testid.ExamID;
        this.practiceObj.practiceName = testid.ExamName;
        let parmars = {
          value: "2", //2是练习。
          examid: testid.ExamID,
          paperid: testid.PaperID,
        };
        this.config.value = JSON.stringify(parmars);
        //生成图片
        setTimeout(() => {
          const canvasIns = html2canvas(this.$refs.codeDownLoad, {
            backgroundColor: "#fff",
            useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
            logging: true,
            scale: 2,
          }).then(
            (canvas) => {
              const url = canvas.toDataURL("image/png", 1.0);
              this.$refs.saveImage.setAttribute("src", url);
            },
            (err) => {
              console.log("err", err);
            }
          );
        }, 500);
      }
    },
    // 判断是否要独立密码进来的校验接口
    async independent() {
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await checkCryptoPwd(params);
      if (Data.status === 200) {
        this.isHavePwd = Data.data.Data.isHavePwd;
        if (this.isHavePwd === 0) {
          // 为0的时候表示没有设置密码去设置密码页面
          // this.cutcoms(3);
          this.$router.push("/user_center/setEncy");
        } else if (this.isHavePwd === 1) {
          this.deleteVisibleis = true; //弹窗开启
        }
      } else {
        this.$message.error("请求失败");
      }
    },
    stt() {
      console.log(this.formLabelAlign.createBeginTime, "日期选择");
    },
    // 验证密码部分
    async verifyPwd() {
      let params = {
        cryptoPwd: md5(this.password),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      this.sundflag = true;

      if (this.password != "") {
        const Data = await verifyCryptoPwd(params);
        if (Data.status === 200) {
          this.isRight = Data.data.Data.isRight;
          // this.goVerifPaw();
          setTimeout(() => {
            this.sundflag = false;
          }, 500);
          if (this.isRight == 1) {
            // this.cutcoms(4); // 为1的时候通过放行
            this.$router.push("/user_center/decryTable");
            this.$store.commit("setPass", this.password);
            sessionStorage.setItem("encryptpaw", this.password);
            // this.password = "";
          } else if (this.isRight == 0) {
            this.deleteVisibleis = true;
            this.verifyError = true; // 密码错误提示语
            this.IsState = "密码错误";
          }
        } else {
          this.sundflag = false;
          this.$message.error("您的网络已奔溃");
        }
      } else {
        this.verifyError = true; // 密码错误提示语
        this.IsState = "请输入密码";
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        console.log("为空了");
      }
    },
    // 取消返回首页

    // 验证跳转是否执行添加按钮
    typeToAdd() {
      if (
        this.$route.query.type !== undefined &&
        this.$route.query.type == "editor"
      ) {
        // this.addtest()
        let row = JSON.parse(sessionStorage.getItem("lxszRow"));
        this.handleClick(row); // 传入当前行
      }
    },
    async init() {
      if (this.$route.query.trainId) {
        // 培训进来的默认直接去添加
        if (this.$route.query.state == 0) {
          // 去添加
          this.addtest();
        } else {
          this.testtype = [];
          // 编辑
          const obj = {
            scoreId: this.$route.query.scoreId,
            type: this.$route.query.type,
            typeId: this.$route.query.typeId,
          };
          const { data } = await training.getTypeDetail(obj);
          if (data.Status == 200) {
            const typeTest = typeTestPaper(data.Data.PaperMode);
            data.Data.PaperModeName = typeTest.PaperModeName;
            data.Data.PaperModeExam = typeTest.PaperModeExam;
            this.statePopupstatus = data.Data;
            // this.editDetails(data.Data);
            localStorage.setItem("isreload", true);
            this.Buriedpoint({
              code: "OnlinePractice:Testpapers:edit",
              parent_code: "OnlinePractice:Testpapers",
            });
            this.cutcoms(2);
          } else {
            this.$message.error(data.Data);
          }
        }
      }
    },
  },
  computed: {
    sumwidth() {
      return "50";
    },
  },
  created() {
    this.stateArr = [];
    this.getDatalist(); // 表格数据
    localStorage.removeItem("isreload");
    this.typeToAdd(); // 跳转添加
  },
  activated() {
    sessionStorage.removeItem("examState"); // 初始化清空组卷状态
    sessionStorage.removeItem("practice");
    this.init();
  },
  mounted() {
    if (
      /Safari/.test(navigator.userAgent) &&
      !/Chrome/.test(navigator.userAgent)
    ) {
      //Safari浏览器兼容性问题。
      this.$refs.tabledata.$el.style.display = "table-cell";
    }
  },
};
</script>

<style lang="scss" scoped>
.mr24 {
  margin-left: 110px;
  font-size: 16px;
}
::v-deep .el-table__body {
  min-width: 1350px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}
.downLoad {
  width: 300px;
  height: 450px;
  background-color: #fff;
  margin-top: 200px;
  .exam_p {
    font-size: 10px;
    margin-left: 30px;
    margin-top: 3px;
  }
  .red_p {
    color: #333333;
    padding-left: 20px;
    font-size: 12px;
    span {
      color: #e54d4d;
      font-size: 12px;
    }
  }
}
.center {
  height: 100%;
  min-width: 1572px;
  background-color: rgb(255, 255, 255);
}
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
}
.hos_table {
  padding: 0px 24px;
  min-height: 560px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
}
.sonbtn {
  border: 1px solid #d9d9d9 !important;
  color: #999999;
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 88px;
  }
  .el-button:nth-child(2) {
    background: #ee6717;
    width: 88px;
  }
  .el-button:nth-child(3) {
    background: #e54d4d;
    width: 104px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
::v-deep .el-range-separator {
  color: #eeeeee !important;
}
::v-deep .el-table .redtwo .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #aaaaaa !important;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #cce7ff;
  color: #333333;
  opacity: 1;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(12) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}

::v-deep .el-table td div:nth-child(1) {
  text-align: center;
}

.operation_box {
  .el-button {
    font-size: 16px;
  }
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
  display: flex;
  justify-content: center;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
  display: flex;
  justify-content: center;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ffa200;
  }
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
  display: flex;
  justify-content: center;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #00d254;
  }
}
.icon-tishi {
  display: inline-block;
  // transform: translate(-6px, -5px) scale(0.6);
  &::before {
    color: #cad8d0;
    display: inline-block;
  }
}

.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      flex: 1;
      width: 80px;
    }
  }
}
.qrcodeView {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog {
    min-width: 342px !important;
    // min-height: 280px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      &:nth-child(2) {
        margin-left: 24px;
      }
    }
  }
}

.qr_p {
  color: #e54d4d;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.exam_p {
  font-size: 14px;
  margin-left: 24px;
  margin-top: 2px;
}
.red_p {
  color: #333333;

  span {
    color: #e54d4d;
    font-size: 16px;
  }
}
.bacle_input {
  display: flex;
  padding-right: 40px;
  .examTimeSelect {
    ::v-deep .el-date-editor {
      width: 550px;
    }
    margin-bottom: 30px;
  }
  ::v-deep .el-input {
    width: 550px;
  }
  h5 {
    display: inline-block;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
  p {
    margin-left: 10px;
    line-height: 40px;
    text-align: center;
  }
}
// 考场开启状态按钮
</style>
<style lang="scss">
.el-table {
  width: 94vw !important;
}
.el-tooltip__popper.is-darkts {
  background: #00d254;
  color: #ffffff;
  > :nth-child(2) {
    border-right: 6px solid #00d254 !important;
    &::after {
      border: none;
    }
  }
}
.el-tooltip__popper.is-dark1 {
  width: 200px;
  height: 70px;
  line-height: 18px;
  background: #ffffff !important;
  box-shadow: 0 0 10px 5px rgba(217, 217, 217, 1);
  > :nth-child(2) {
    border-right: 6px solid #ffffff !important;
    &::after {
      border: none;
    }
  }
}
.el-tooltip__popper.is-dark2 {
  width: 200px;
  height: 70px;
  line-height: 18px;
  background: #ffffff !important;
  box-shadow: 0 0 10px 5px rgba(217, 217, 217, 1);
  > :nth-child(2) {
    border-left: 6px solid #ffffff !important;
    &::after {
      border: none;
    }
  }
}
.el-tooltip__popper.is-dark4 {
  width: 200px;
  height: 52px;
  line-height: 18px;
  background: #ffffff !important;
  box-shadow: 0 0 10px 5px rgba(217, 217, 217, 1);
  > :nth-child(2) {
    border-left: 6px solid #ffffff !important;
    &::after {
      border: none;
    }
  }
}
.el-tooltip__popper.is-dark3 {
  width: 200px;
  height: 52px;
  line-height: 18px;
  background: #ffffff !important;
  box-shadow: 0 0 10px 5px rgba(217, 217, 217, 1);
  > :nth-child(2) {
    border-right: 6px solid #ffffff !important;
    &::after {
      border: none;
    }
  }
}
.el-tooltip__popper.is-dark5 {
  width: 361px;
  line-height: 18px;
  background: #00d254 !important;
  box-shadow: 0 0 10px 1px rgba(0, 210, 84, 1);
  color: #ffffff;
  > :nth-child(2) {
    border-right: 6px solid #00d254 !important;
    &::after {
      border: none;
    }
  }
}
.el-tooltip__popper.is-dark6 {
  width: 330px;
  line-height: 18px;
  background: #00d254 !important;
  box-shadow: 0 0 10px 1px rgba(0, 210, 84, 1);
  color: #ffffff;
  > :nth-child(2) {
    border-right: 6px solid #00d254 !important;
    &::after {
      border: none;
    }
  }
}
.el-form {
  display: flex;
  ::v-deep .el-input > .el-input__inner {
    width: 200px;
  }
}
.qr_v {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_ {
  display: flex;
  justify-content: center;
  align-items: center;
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
//@at-root
.isselectico {
  color: #1890ff;
  cursor: pointer;
}
// 弹窗
.password_view {
  .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .el-dialog {
    width: 441px;
    height: 380px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
  .dialog-footer {
    margin-bottom: 30px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .el-dialog__footer {
    padding: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-content: center;
    span > button {
      width: 88px;
      height: 32px;
      opacity: 1;
      border-radius: 4px;
      padding: 0px;
      margin-top: 38px;
    }
    span > button:nth-child(1) {
      background: #eeeeee;
      color: #aaaaaa;
    }
    span > button:nth-child(2) {
      margin-left: 50px;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-input__suffix-inner {
    line-height: 54px;
    padding-right: 10px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  .el-form-item.is-error .el-input__validateIcon {
    display: none;
  }
  span > button:nth-child(2) {
    margin-left: 50px !important;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .password_mian {
    display: flex;
    flex-direction: column;
    padding: 20px 23px;
    box-sizing: border-box;
    p {
      text-align: left;
      font-size: 15px;
      margin: 5px 0 25px 0;
    }
    .el-input__inner {
      height: 56px;
      margin-bottom: 20px;

      .el-input__suffix-inner > i {
        font-size: 22px;
      }
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}

.verifyError {
  color: red;
}
.isError {
  color: red;
  position: absolute;
  left: 0;
  top: 51px;
}
::v-deep .el-message-box {
  .el-message-box__btns {
    text-align: center !important;
  }
}

.everywhere {
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-dialog {
    width: 380px !important;
    min-height: 205px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__header {
    height: 55px;
    opacity: 1;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
}
.teststatus {
  text-align: center;
}
::v-deep .el-progress-bar {
  width: 300px;
}
</style>
